import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { useLicenseEntitlementLimit } from '#layers/access/composables/use-license-entitlement-limit';
import { CREATE_MODE_ITEM_ID } from '#layers/data-model/public';

/**
 * Route-level backstop for the policy-create page. The create action already guards, but the
 * detail route is directly reachable by URL, so a hard-blocked user could bypass it. Only guards
 * the create route (not editing an existing policy) and redirects to the policies listing when
 * custom policies are hard-blocked. Soft limits stay reachable; non-admins fail open.
 */
export default defineNuxtRouteMiddleware(async (to) => {
	if (to.params.policy !== CREATE_MODE_ITEM_ID) return;

	const { isCreationBlocked } = useLicenseEntitlementLimit();

	if (await isCreationBlocked('custom_policies')) {
		return { name: 'workspace.settings.access.policies.listing', params: { workspace: to.params.workspace } };
	}
});
